import { derived, readable } from "svelte/store";
import { State } from "./State";
export class Game {
    constructor(eventsChannelFactory, id, code, roomId, managerId, creationDate, type, state, waitTime, numbers, useCheckers, playWithPaper) {
        var _a;
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.code = code;
        this.roomId = roomId;
        this.managerId = managerId;
        this.creationDate = creationDate;
        this.type = type;
        this.waitTime = waitTime;
        this.useCheckers = useCheckers;
        this.playWithPaper = playWithPaper;
        this.timeToStart = readable(this.getTimeToStart(), set => {
            if (this.getTimeToStart() === 0) {
                set(0);
                return;
            }
            const timeout = window.setInterval(() => {
                const timeToStart = this.getTimeToStart();
                //Si no queda tiempo detenemos el intervalo
                if (timeToStart === 0) {
                    window.clearInterval(timeout);
                }
                set(timeToStart);
            }, 1000);
            return () => window.clearInterval(timeout);
        });
        this.waitingEnded = derived(this.timeToStart, timeToStart => timeToStart === 0);
        this.state = new State(state);
        this.numbers = new State(numbers);
        this.lastNumber = new State((_a = numbers[numbers.length - 1]) !== null && _a !== void 0 ? _a : null);
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`game.${this.id}`);
    }
    hasNumber(number) {
        return this.numbers.value.includes(number);
    }
    addNumber(number) {
        if (this.hasNumber(number)) {
            return;
        }
        this.numbers.value.push(number);
        this.numbers.beat();
        this.lastNumber.set(number);
    }
    /**
     * Retorna el tiempo en segundos que faltan para que comience el juego.
     * No retornará números negativos.
     */
    getTimeToStart() {
        const startGame = new Date(localStorage.getItem('gameStart'));
        const startTime = /* this.creationDate.getTime() */ startGame.getTime() + (this.waitTime * 60 * 1000);
        return Math.max(0, Math.floor((startTime - Date.now()) / 1000));
    }
}
